// Where "add item here" actually files things.
//
// Here. Always here, with no exceptions, and it took four attempts to stop looking for one.
//
// The first version walked down the tree picking the alphabetically-first child at each step, on the
// theory that a dresser is a container and the item really belongs in a drawer. Standing in My
// house, "Add item" landed in House › Basement › Shelf 1 — somewhere the user had never opened. The
// second kept one level of that: standing in a Dresser it aimed at Aardvark drawer, and going up a
// level from Top drawer retargeted to that drawer's *sibling*, which is why it was reported as the
// destination failing to update. The third removed descent entirely. The fourth put back a descent
// restricted to the case where the location has exactly one child — the reasoning being that one
// child is a fact about the tree rather than a guess about the user, so nothing could be wrong.
//
// That reasoning is wrong, and it is worth writing down why, because it is persuasive:
//
//   "The scan location should always be where add item was clicked from. Why would we ever break
//   that?"
//
// Opening the camera from a location is not a hint to be improved on. It is the user saying where
// they are, with a tap, on a screen showing them that place. Ambiguity was never the problem —
// *overriding an explicit statement* was, and a single child makes the override tidier rather than
// less of one. The rule has no exception because the moment it has one, "Adding to X" stops being a
// readback of what the user did and becomes a claim they have to check.
//
// Going deeper is a separate gesture: the > arrow in the scan header steps in one level, and only
// where there is no ambiguity about where. That is the same single-child condition — the difference
// is that pressing it is the user asking. See src/scan-nav.js.

// locations: every visible location, each with `id`, `name` and `parent_location_id`. Unused now
// that the answer needs no knowledge of the tree; kept so the call sites and the tests do not churn
// if the rule ever regains a condition, and so this stays the one named place that answers the
// question rather than `loc.id` repeated at four call sites.
export function firstScanTarget(locations, locationId) {
  return locationId;
}
